module.exports = __webpack_public_path__ + "static/9-ebe8ba93f354c2b6679af3c1961129bb.jpeg";